import React from 'react';
import { Route, Switch } from 'react-router-dom'
import { LocaleProvider } from 'antd';
import zhCN from 'antd/lib/locale-provider/zh_CN';
import moment from 'moment'; 
import 'moment/locale/zh-cn'; 
import LoadableFunc from '../../common/loadable'
import './index.module.scss'
moment.locale('zh-cn');
const homePage = LoadableFunc(()=>import('../homePage'));
const PersonPropertyCheck = LoadableFunc(()=>import('../personPropertyCheck'));
const Page404 = LoadableFunc(()=>import('../Page404'));
const userGuide = LoadableFunc(()=>import('../userGuide'));
const Artice = LoadableFunc(()=>import('../Artice'));
const Policy = LoadableFunc(()=>import('../Policy'));
const HouseAuditDetail = LoadableFunc(()=>import('../houseAuditDetail'));
const HouseAuditList = LoadableFunc(()=>import('../houseAuditList'));
const HouseDetail = LoadableFunc(()=>import('../houseDetail'));
const MyContract=LoadableFunc(()=>import('../ContractList'))
const personMainPage=LoadableFunc(()=>import('../personMainPage'))
const personIdentifiedPage=LoadableFunc(()=>import('../personIdentifiedPage'))
const ReleaseRentalHousing = LoadableFunc(()=>import('../releaseRentalHousing'));
const PersonMsgPage = LoadableFunc(()=>import('../personMsgPage'));
const PersonRegisterPage = LoadableFunc(()=>import('../personRegisterPage'));
const PropertyVerificate = LoadableFunc(()=>import('../propertyVerificate'));
const RecordContract=LoadableFunc(()=>import('../ContractRecord'));
const PersonHousePage=LoadableFunc(()=>import('../personHousePage'));
const EditHouseInfo=LoadableFunc(()=>import('../editHouseInfo'));
const ContractEdit=LoadableFunc(()=>import('../ContractEdit'));
const ContractView=LoadableFunc(()=>import('../ContractView'));

const RentHouseSource=LoadableFunc(()=>import('../rentHouseSource'));
const RentHousePage=LoadableFunc(()=>import('../rentHousePage'));
const RentHousePropose=LoadableFunc(()=>import('../rentHousePropose'));
const RentHouseGuide=LoadableFunc(()=>import('../rentHouseGuide'));
const RentHouseOrg=LoadableFunc(()=>import('../rentHouseOrg'));

const NewRentHouseSource=LoadableFunc(()=>import('../newRentHouse/rentHouseSource'));
const NewRentHousePage=LoadableFunc(()=>import('../newRentHouse/rentHousePage'));
const NewRentHousePropose=LoadableFunc(()=>import('../newRentHouse/rentHousePropose'));
const NewRentHouseGuide=LoadableFunc(()=>import('../newRentHouse/rentHouseGuide'));
const NewRentHouseOrg=LoadableFunc(()=>import('../newRentHouse/rentHouseOrg'));
const NewRentHouseGuarantee=LoadableFunc(()=>import('../newRentHouse/rentHouseGuarantee'));
const NewRentHouseGuaranteeDetail=LoadableFunc(()=>import('../newRentHouse/rentHouseGuaranteeDetail'));
const NewRentHouseInsurance=LoadableFunc(()=>import('../newRentHouse/rentHouseInsurance'));
const NewRentHouseActivity=LoadableFunc(()=>import('../newRentHouse/rentHouseActivity'));

const RentHouseGrad=LoadableFunc(()=>import('../rentHouseGrad'));

const NewRentHouseGrad=LoadableFunc(()=>import('../newRentHouseGrad'));
// const RentalGuideGrad=LoadableFunc(()=>import('../newRentHouseGrad/rentalGuideGrad'));
// const InitiativeGrad=LoadableFunc(()=>import('../newRentHouseGrad/initiativeGrad'));
// const CompaniesGrad=LoadableFunc(()=>import('../newRentHouseGrad/companiesGrad'));
// const ListingsGrad=LoadableFunc(()=>import('../newRentHouseGrad/listingsGrad'));
// const ListingGradDetail=LoadableFunc(()=>import('../newRentHouseGrad/listingGradDetail'));
// const InsuredGrad=LoadableFunc(()=>import('../newRentHouseGrad/insuredGrad'));
// const InsuredGradDetail=LoadableFunc(()=>import('../newRentHouseGrad/insuredGradDetail'));
// const GuaranteeGrad=LoadableFunc(()=>import('../newRentHouseGrad/guaranteeGrad'));
// const ActivityGrad=LoadableFunc(()=>import('../newRentHouseGrad/activityGrad'));
// 下线修改指向为首页 以下上线活动后请注释
const RentalGuideGrad=LoadableFunc(()=>import('../newRentHouseGrad'));
const InitiativeGrad=LoadableFunc(()=>import('../newRentHouseGrad'));
const CompaniesGrad=LoadableFunc(()=>import('../newRentHouseGrad'));
const ListingsGrad=LoadableFunc(()=>import('../newRentHouseGrad'));
const ListingGradDetail=LoadableFunc(()=>import('../newRentHouseGrad'));
const InsuredGrad=LoadableFunc(()=>import('../newRentHouseGrad'));
const InsuredGradDetail=LoadableFunc(()=>import('../newRentHouseGrad'));
const GuaranteeGrad=LoadableFunc(()=>import('../newRentHouseGrad'));
const ActivityGrad=LoadableFunc(()=>import('../newRentHouseGrad'));


const SearchRentInfo=LoadableFunc(()=>import('../searchRentInfo'));
const PersonSearchRent=LoadableFunc(()=>import('../personSearchRent'));
const ReleaseSearchRent=LoadableFunc(()=>import('../ReleaseSearchRent'));
const EditSearchRent=LoadableFunc(()=>import('../editSearchRent'));
const VerificateQuery=LoadableFunc(()=>import('../verificateQuery'));
// const ActivityZiru=LoadableFunc(()=>import('../activityPage/ziru'));
// const ActivityAnXin=LoadableFunc(()=>import('../activityPage/anxin'));
// const ActivityLehu=LoadableFunc(()=>import('../activityPage/lehu'));

// const ActivityXiangyu=LoadableFunc(()=>import('../activityPage/xiangyu'));
// const ActivityDanke = LoadableFunc(()=>import('../activityPage/danke'));
const UpdateSystem=LoadableFunc(()=>import('../updateSystem'));

const App = () => (
    <LocaleProvider locale={zhCN}>
        <div>
            <Switch>
                 {/* 5.7.4 下架 start */}
                 <Route exact path="/" component={Page404}/>
                {/* 
                <Route exact path="/HouseAuditList" component={HouseAuditList}/>
                <Route exact path="/HouseAuditDetail" component={HouseAuditDetail}/>
                <Route exact path="/person/MyContract" component={MyContract}/>
                <Route exact path="/person/personMainPage" component={personMainPage}/>
                <Route exact path="/person/personIdentifiedPage" component={personIdentifiedPage}/>
                <Route exact path="/person/personMsgPage" component={PersonMsgPage}/>
                <Route exact path="/person/PersonRegisterPage" component={PersonRegisterPage}/>
                <Route  path="/person/personHousePage" component={PersonHousePage} />
                <Route exact path="/Policy" component={Policy} /> */}
                 {/* 5.7.4 下架 end */}
                {/* <Route path="/releaseRentalHousing" component={ReleaseRentalHousing}/> */}
                {/* 5.7.4 下架 start */}
                {/* <Route exact path="/propertyVerificate" component={PropertyVerificate} />
                <Route exact path="/person/personPropertyCheck" component={PersonPropertyCheck} />
                <Route  path="/person/personSearchRent" component={PersonSearchRent} />
                <Route path="/RecordContract" component={RecordContract} />
                <Route path="/Policy/show" component={Artice} />
                <Route  path="/editHouseInfo" component={EditHouseInfo} />
                <Route  path="/editContract" component={ContractEdit} />
                <Route  path="/viewContract" component={ContractView} />
                <Route path="/userGuide" component={userGuide} /> */}

                {/* 5.7.4 下架 end */}

                {/* 毕业季房源页面 */}
                {/* <Route  path="/rentHouseList" component={RentHouseSource} />
                <Route  path="/rentHouseSource" component={RentHousePage} />
                <Route  path="/rentHouseGuide" component={RentHouseGuide} />
                <Route  path="/rentHouseOrg" component={RentHouseOrg} />
                <Route  path="/rentHousePropose" component={RentHousePropose} /> */}
                {/* 返工福利 */}
                
                {/* <Route  path="/rentHouseSource" component={NewRentHousePage} /> 
                
                <Route  path="/rentHouseList" component={NewRentHouseSource} />
                <Route  path="/rentHouseGuide" component={NewRentHouseGuide} />
                <Route  path="/rentHouseOrg" component={NewRentHouseOrg} />
                <Route  path="/rentHousePropose" component={NewRentHousePropose} />
                <Route  path="/rentHouseGuarantee" component={NewRentHouseGuarantee} />
                <Route  path="/rentHouseGuaranteeDetail" component={NewRentHouseGuaranteeDetail} />
                <Route  path="/rentHouseInsurance" component={NewRentHouseInsurance} />
                <Route  path="/rentHouseActivity" component={NewRentHouseActivity} /> */}
                

                {/* 房源详情 */}
                {/* <Route exact path="/houseDetail" component={HouseDetail}/> */}

                {/* <Route  path="/rentSearchInfo" component={SearchRentInfo}/> */}
               
                
                {/* <Route  path="/activity/ziru" component={ActivityZiru} />
                <Route  path="/activity/xiangyu" component={ActivityXiangyu} />
                <Route  path="/activity/danke" component={ActivityDanke} />
                <Route  path="/activity/anxin" component={ActivityAnXin} />
                <Route  path="/activity/lehu" component={ActivityLehu} /> */}

                {/* 5.7.4 下架 */}

                {/* <Route  path="/verificateQuery" component={VerificateQuery} /> */}
                {/* <Route  path="/releaseSearchRent" component={ReleaseSearchRent} />
                <Route  path="/editSearchRent" component={EditSearchRent} /> */}
                



                {/* 毕业季租房活动 */}
                {/* <Route  path="/rentHouseGrad" component={RentHouseGrad} /> */}
                {/* 0930下架 */}
                <Route exact path="/newRentHouseGrad" component={NewRentHouseGrad} />
                <Route  path="/rentalGuideGrad" component={RentalGuideGrad} />
                <Route  path="/initiativeGrad" component={InitiativeGrad} />
                <Route  path="/companiesGrad" component={CompaniesGrad} />
                <Route  path="/listingsGrad" component={ListingsGrad} />
                <Route  path="/insuredGrad" component={InsuredGrad} />
                <Route  path="/insuredGradDetail" component={InsuredGradDetail} />
                <Route  path="/listingGradDetail" component={ListingGradDetail} />
                <Route  path="/guaranteeGrad" component={GuaranteeGrad} />
                <Route  path="/activityGrad" component={ActivityGrad} />

                <Route  path="*" component={Page404}/>
            </Switch>
        </div>
    </LocaleProvider>
);

export default App


// WEBPACK FOOTER //
// ./src/containers/app/index.js